<template>
  <v-container fluid>
    <v-card>
      <!-- start of tabs -->
      <v-tabs background-color="toolbarColor">
        <v-tab to="/stock/report/audit"> Stock Audit </v-tab>
      </v-tabs>
      <!-- end of tabs -->

      <v-card-text>
        <router-view/>
      </v-card-text>
    </v-card>
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  components: {},
  data: () => ({}),
  methods: {},
};
</script>